import { RadioEmpty2, RadioFilled2 } from "@assets";
import { RadioButtonProps } from "./types";

export const RadioButton = ({
  style,
  value,
  onClick,
  disabled,
  unfilledColor,
}: RadioButtonProps) => {
  return (
    <div
      onClick={disabled ? undefined : onClick}
      style={{
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : 1,
        ...style,
      }}
    >
      {value ? <RadioFilled2 size={20} /> : <RadioEmpty2 size={20} fill={unfilledColor} />}
    </div>
  );
};
